import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showDocumentSettingsEditDialog } from 'app/main/components/dialogs/DocumentSettingsEditDialog';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

export default {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'requests'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'requests', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'requests'),
				action: ({ model, t }) => {
					const { reqs_title } = model;
					Utils.openLink({
						pathname: '/requests/add',
						state: {
							model: { ...model, reqs_title: reqs_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'requests', note_table_uid: model.reqs_uid } }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'requests',
							id: model.reqs_uid,
							title: model.reqs_title,
							updateRefresh
						})
					),
				hidden: ({ authorizer }) => {
					return authorizer.cannot('delete', 'requests');
				}
			}
		],
		headerButtons: [
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'requests'),
				action: () => Utils.openLink({ pathname: '/requests/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_REQUESTS_DOCUMENTS_SETTINGS',
				icon: 'folder-wrench',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'requests'),
				action: ({ model, dispatch, sysSettings, updateRefresh }) =>
					dispatch(
						showDocumentSettingsEditDialog({
							module: 'requests',
							itemUid: model.reqs_uid,
							folderName: model.reqs_foldername,
							docsFolderPath: sysSettings.docs_path,
							updateRefresh
						})
					)
			},
			{
				name: 'VIEW_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				disabled: ({ isEdit }) => isEdit,
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'requests',
							id: model.reqs_uid,
							title: model.reqs_title
						})
					),
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'requests')
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'requests'),
				action: ({ switchEdit }) => switchEdit()
			}
		]
	}
} as ModuleButtonsType;
